module.exports = __webpack_public_path__ + "img/process-4.039dfe78.png";